import { render, staticRenderFns } from "./ParcelaInfo.vue?vue&type=template&id=c63eb3c6&scoped=true"
import script from "./ParcelaInfo.vue?vue&type=script&lang=js"
export * from "./ParcelaInfo.vue?vue&type=script&lang=js"
import style0 from "./ParcelaInfo.vue?vue&type=style&index=0&id=c63eb3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63eb3c6",
  null
  
)

export default component.exports